import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Upload: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[19px] h-[18px] stroke-[2px]', className)}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 2.25C9.30109 2.25 9.11032 2.32902 8.96967 2.46967L5.96967 5.46967C5.67678 5.76256 5.67678 6.23744 5.96967 6.53033C6.26256 6.82322 6.73744 6.82322 7.03033 6.53033L8.75 4.81066V12C8.75 12.4142 9.08579 12.75 9.5 12.75C9.91421 12.75 10.25 12.4142 10.25 12V4.81066L11.9697 6.53033C12.2626 6.82322 12.7374 6.82322 13.0303 6.53033C13.3232 6.23744 13.3232 5.76256 13.0303 5.46967L10.0303 2.46967C9.88968 2.32902 9.69891 2.25 9.5 2.25ZM15.5 11.25C15.0858 11.25 14.75 11.5858 14.75 12V13.5C14.75 13.9142 14.4142 14.25 14 14.25L5 14.25C4.58578 14.25 4.25 13.9142 4.25 13.5V12C4.25 11.5858 3.91421 11.25 3.5 11.25C3.08578 11.25 2.75 11.5858 2.75 12V13.5C2.75 14.7426 3.75736 15.75 5 15.75L14 15.75C15.2426 15.75 16.25 14.7426 16.25 13.5V12C16.25 11.5858 15.9142 11.25 15.5 11.25Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Upload;
